var map = {
	"./cerf.png": 5994,
	"./cochon.png": 2494,
	"./koala.png": 2306,
	"./lapin.png": 7938,
	"./loup.png": 7018,
	"./loup_blanc.png": 317,
	"./ours.png": 9507,
	"./ours_blanc.png": 9336,
	"./panda.png": 4320,
	"./pingouin.png": 2084,
	"./renard.png": 3056,
	"./rennes.png": 5409,
	"./zebre.png": 1608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2296;